export const TRIP_EXTRAS_HELP_ARTICLE_URL = 'https://help.fleetwire.io/en/article/add-and-customize-trip-extras-in-fleetwire-440v22/?bust=1747328838295';

export const TRIP_EXTRA_VISIBILITY_TOOLTIP = 'Visible extras appear on checkout for customers to add. Hidden extras are omitted from checkout and can only be added manually in the back office.';

export const tripExtraVisibilityTippy = {
    allowHTML: true,
    interactive: true,
    arrow: true,
    content: `${TRIP_EXTRA_VISIBILITY_TOOLTIP} <a href="${TRIP_EXTRAS_HELP_ARTICLE_URL}" target="_blank" rel="noopener noreferrer" style="color: rgb(var(--v-theme-primary)); text-decoration: underline;">Learn more</a>`,
};
